<template>
  <div id="scroll-threshold-example" class="review-page">
    <div>
      <div class="mt-5" v-if="settings&&settings.options">
        <v-row :class="$vuetify.breakpoint.smAndDown?'':'mx-1'">
          <v-col cols="12">
            <v-container style="max-width:640px">
                <v-row class="px-3">
                  <v-col cols="12" md="12" class="pb-0">
                    <v-card class="brand-card" flat>
                      <div class="brand-card-inner">
                        <v-img
                          :src="'/static/users/pictures/db/'+settings.options.logoDB"
                          :lazy-src="'/static/users/pictures/db/'+settings.options.logoDB"
                          class="brand-logo"
                        >
                        </v-img>
                      </div>
                    </v-card>
                    <div v-if="bookingId" class="greeting-block text-center">
                      <span class="eyebrow">{{$t(page+'.Dear')}}</span>
                      <span class="guest-name" v-if="booking.firstName||booking.lastName">{{booking.firstName?booking.firstName+ ' ' :'' + booking.lastName?booking.lastName:''}}</span>
                    </div>
                  </v-col>
                  <v-col cols="12" v-if="user==={}">
                    <v-card class="text-center brand-card py-8" flat>
                      <v-progress-circular indeterminate size="64" width="3" color="#000000"></v-progress-circular>
                    </v-card>
                  </v-col>
                  <template v-else>
                    <v-col cols="12" class="order-3 pt-0">

                      <div class="">
                        <div class="section-title text-h5 text-center" style="color:#000000">
                          {{$t(page+'.RATE YOUR EXPERIENCE')}}
                        </div>
                        <div class="rating-list">
                            <template v-for="(v,n,i) in review">
                              <template v-if="n=='food'||n=='service'||n=='value'||n=='location'">
                                <div :key="i" class="rating-row">
                                  <div class="rating-label">{{$t(page+'.'+n)}}</div>
                                  <div class="rating-row-bottom">
                                    <v-rating
                                      v-model="review[n]"
                                      size="28"
                                      hover
                                      background-color="#d7d2c8"
                                      color="#000000"
                                      empty-icon="mdi-circle-outline"
                                      full-icon="mdi-circle"
                                      class="rating-dots"
                                      ></v-rating>
                                    <div v-if="review[n]>0" class="rating-state">{{$t(page+'.'+ratingLabelKey(review[n]))}}</div>
                                  </div>
                                </div>
                              </template>
                            </template>
                        </div>
                      </div>

                      <div class="ta-section">
                        <div class="section-title">
                          {{$t(page+'.Write a review')}}
                          <!--
                          <div class="tip-line float-right pr-3" @click="dialog_tips = true">
                            <v-icon small color="amber darken-2">mdi-lightbulb-on-outline</v-icon>
                            <span class="tip-link">{{$t(page+'.Tips')}}</span>
                          </div>
                          -->                          
                        </div>
                        <!--
                        <div class="text-caption">
                          {{$t(page+'.'+'Note from the owner')}}:
                          <br />{{$t(page+'.'+'sentence_0')}}.
                        </div>
                        -->
                        <v-textarea
                          v-model="review.review"
                          outlined
                          auto-grow
                          counter
                          minlength=25
                          rows="4"
                          class="ta-input mt-3"
                        >
                        </v-textarea>
                      </div>

                      <div class="ta-section">
                        <div class="section-title">
                          {{ $t(page + '.How did you find us') }}
                        </div>

                        <v-radio-group v-model="review.source" class="mt-0 pt-0">
                          <v-row align="center">
                            <v-col
                              v-for="opt in sourceOptions"
                              :key="opt"
                              cols="6"
                              class="py-1"
                            >
                              <v-radio
                                :label="$t(page + '.' + opt)"
                                :value="opt"
                                class="ma-0"
                                color="#000000"
                              ></v-radio>
                            </v-col>
                          </v-row>
                        </v-radio-group>
                      </div>

                      <div class="ta-section">
                        <v-btn
                          color="#000000"
                          dark
                          depressed
                          :loading="loading"
                          block
                          class="submit-btn text-h6"
                          @click="saveReview()"
                          :disabled="review.food===0||review.service===0||review.value===0||review.location===0||!review.source"
                        >
                            {{$t(page+'.Send Review')}}
                        </v-btn>
                      </div>
                    </v-col>
                  </template>
                </v-row>
            </v-container>
          </v-col>
        </v-row>
      </div>
    </div>
    <v-btn
      v-if="settings"
      v-scroll="onScroll"
      v-show="scrollToTop"
      fab
      dark
      small
      fixed
      bottom
      right
      color="#000000"
      @click="toTop"
    >
      <v-icon>keyboard_arrow_up</v-icon>
    </v-btn>
    <v-bottom-navigation
      color="orange"
      absolute
      hide-on-scroll
      scroll-target="#scroll-threshold-example"
      scroll-threshold="500"
      class="social-nav"
      style="position:unset"
      v-if="settings"
    >
      <v-btn :href="settings.options.facebookURL" v-if="settings.options.facebookURL" text>
        <span>Facebook</span>
        <v-icon color="#3b5998">mdi-facebook</v-icon>
      </v-btn>
      <v-btn :href="settings.options.instagramURL" v-if="settings.options.instagramURL" text>
        <span>Instagram</span>
        <v-icon color="#C13584">mdi-instagram</v-icon>
      </v-btn>
      <v-btn :href="settings.options.youtubeURL" v-if="settings.options.youtubeURL" text>
        <span>YouTube</span>
        <v-icon color="#c4302b">mdi-youtube</v-icon>
      </v-btn>
      <v-btn :href="settings.options.linkedInURL" v-if="settings.options.linkedInURL" text>
        <span>LinkedIn</span>
        <v-icon color="#0077b5">mdi-linkedin</v-icon>
      </v-btn>
    </v-bottom-navigation>
    <div id="scroll-threshold-example">
      &nbsp;
    </div>
    <v-dialog v-model="dialog_tips"
      width="420"
      v-if="dialog_tips"
    >
      <v-card class="dialog-card">
        <v-card-title class="dialog-title">
          {{$t(page+'.Tips')}}
          <v-spacer></v-spacer>
          <v-btn fab icon small @click="dialog_tips = false">
            <v-icon color="grey darken-1">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="dialog-text pa-5">
          <ul class="tips-list">
            <li>{{$t(page+'.sentence_1')}}</li>
            <li>{{$t(page+'.sentence_2')}}</li>
            <li>{{$t(page+'.sentence_3')}}</li>
            <li>{{$t(page+'.sentence_4')}}</li>
          </ul>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_thanks"
      width="420"
      v-if="dialog_thanks"
    >
      <v-card class="dialog-card">
        <v-card-title class="dialog-title">
          {{$t(page+'.Thanks')}} <v-icon color="red">mdi-heart</v-icon>
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small @click="dialog_thanks = false">
                <v-icon color="grey darken-1">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>{{$t(page+'.Close')}}</span>
          </v-tooltip>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="dialog-text pa-5">
          <div>
            <p>{{$t(page+'.Thanks for your feedback')}} </p>
              <template v-if="(parseFloat(totalScore/4))>=parseFloat(settings.minScore)">
                <div v-if="settings.options.reviewCouponClass=='conditionalCoupon'">
                  <p>{{$t(page+'.We decided to send you a FREE COUPON')}}</p>
                </div>
                <template v-if="settings.options.tripadvisorReviewRequestEnable=='1'&&settings.options.reviewTripadvisorURL!=''&&settings.options.googleReviewRequestEnable!='1'">
                  <!-- TA ONLY -->
                  <p>{{$t(page+'.Click on the button to share your review on Tripadvisor')}} <span v-if="settings.options.reviewCouponClass!='noCoupon'"> {{$t(page+'.and discover your FREE COUPON')}}</span></p>
                </template>
                <template v-if="settings.options.googleReviewRequestEnable=='1'&&settings.options.reviewGoogleURL!=''&&settings.options.tripadvisorReviewRequestEnable!='1'">
                  <!-- G ONLY -->
                  <p>{{$t(page+'.Click on the button to share your review on Google')}} <span v-if="settings.options.reviewCouponClass!='noCoupon'"> {{$t(page+'.and discover your FREE COUPON')}}</span></p>
                </template>
                <template v-if="settings.options.tripadvisorReviewRequestEnable=='1'&&settings.options.reviewTripadvisorURL!=''&&settings.options.googleReviewRequestEnable=='1'&&settings.options.reviewGoogleURL!=''">
                  <!-- BOTH -->
                  <p>{{$t(page+'.Click on the button to share your review on Tripadvisor or Google')}} <span v-if="settings.options.reviewCouponClass!='noCoupon'"> {{$t(page+'.and discover your FREE COUPON')}}</span></p>
                </template>
                <v-btn @click="clicked('ta')" v-if="settings.options.tripadvisorReviewRequestEnable=='1'&&settings.options.reviewTripadvisorURL!=''" color="#00af87" outlined block class="mt-2" :href="settings.options.reviewTripadvisorURL">
                  Tripadvisor
                </v-btn>
                <v-btn class="mt-2" @click="clicked('go')" v-if="settings.options.googleReviewRequestEnable=='1'&&settings.options.reviewGoogleURL!=''" color="#4285F4" outlined block :href="settings.options.reviewGoogleURL">
                  Google
                </v-btn>
              </template>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_duplicated"
      width="420"
      v-if="dialog_duplicated"
    >
      <v-card class="dialog-card">
        <v-card-title class="dialog-title">
          {{$t(page+'.Review')}}
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small @click="dialog_duplicated = false">
                <v-icon color="grey darken-1">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>{{$t(page+'.Close')}}</span>
          </v-tooltip>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="dialog-text pa-5 text-center">
          <div>
            {{$t(page+'.Review already released')}}
          </div>
          <p class="pt-6"><v-icon color="red" style="font-size:80px">mdi-heart</v-icon></p>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar.active"
      top
      timeout="2000"
      class=""
      :color="snackbar.color"
    >
      {{snackbar.text}}
    </v-snackbar>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import QrcodeVue from 'qrcode.vue'
export default {
   components: {
      QrcodeVue,
    },
  data() {
    return {
      page: "Review",
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      dialog_thanks:false,
      dialog_leave_to_tripadvisor:false,
      dialog_connection_error:false,
      dialog_duplicated:false,
      dialog_tips:false,
      loading:false,
      origin:null,
      date:null,//new Date().toISOString().substring(0,10),
      today:new Date().toISOString().substring(0,10),
      locale:'it',
      snackbar:{active:false,color:'success',text:''},
      reviewSaved:false,
      uu:null,
      user:{},
      booking:{firstName:null,lastName:null},
      bookingId:null,
      totalScore:0,
      partialScore:0,
      review:{"food":0,"service":0,"value":0,"location":0,"review":null,"source":null},
      sourceOptions:['google','facebook','instagram','tripadvisor','website','word_of_mouth'],
      settings:null,
      reviewPrizeValidUntil:null,
      QRCodeLink:null,
      payloads:null,
      hostname:null,
    };
  },
  created(){
    this.$vuetify.theme.dark=false;
    //localStorage.removeItem('uu');
    sessionStorage.removeItem('jwt');
    const la=window.navigator.userLanguage||window.navigator.language;
    this.$store.dispatch("setLocale",la.substring(0,2));
    //console.log(813,this.uu)
    this.bookingId=this.$route.query.p;
    console.log(818,this.$route,this.$route.query,this.$route.query.bookingid);
    //console.log(819,window.location.href);
    this.origin=this.$route.path;
    console.log(347,this.origin);
    this.review.review=''
    this.Authenticate(this.bookingId)
  },
  mounted: function () {

  },
  computed : {
    ...mapGetters(["settings","countries"]),
  },
  watch : {
  },
  methods:
  {
    ratingLabelKey(v) {
      const map = {1:'Terrible',2:'Poor',3:'Average',4:'VeryGood',5:'Excellent'};
      return map[v] || '';
    },
    addDaysFormatted(days) {
      var result = new Date();
      result.setDate(result.getDate() + days);
      return result.toLocaleDateString( this.settings.locale,{ weekday: 'long',  month: 'long', day: 'numeric' });
    },
    onScroll (e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset ||   e.target.scrollTop || 0
      this.scrollToTop = top > 20
    },
    toTop () {
      this.$vuetify.goTo(0)
    },
    async Authenticate(bookingId){
      this.loading=true;
      //try{
          const payload=JSON.stringify({"action":"AuthenticateReview","payload":{"bookingId":bookingId}});
          const res = await this.$http.post('/review/review.php', payload );
          console.log(1026,res);
          switch (res.data.errorid)
          {
            case '0':
              sessionStorage.setItem('jwt', res.data.jwt);
              sessionStorage.setItem('settings', JSON.stringify(res.data.payloads.settings));
              console.log(966,document.link)

              //document.querySelector("link[rel*='icon']").href = this.settings.favicon?'/favicons/'+this.settings.favicon:"/favicon.ico";
              this.$store.dispatch("setSettings",res.data.payloads);
              this.settings=res.data.payloads;
              document.title = this.settings.brand + ' | Review';
              this.booking.firstName=this.settings.firstName;
              this.booking.lastName=this.settings.lastName;
              this.booking.brand=this.settings.brand;
              this.settings.avatar=this.settings.avatar;
              this.$store.dispatch("setAvatar",this.settings.avatar);

              //console.log(918,this.user);

            break;
            case '0001':

            break
            case '0006':
              this.$router.push('/auth/login').catch(() => {});
            break;
          }
          this.loading= false;
      /*} catch(e)
      {
          this.dialog_connection_error=true;
          console.error(1215,e);
      }*/
    },
    async clicked(channel)
    {
      var review= {... this.review}
      review.channel=channel;
      review.bookingId=this.bookingId;
      let payload={"action":'clickedReview',"payload":review}
      console.log(1259,payload)
      let w= await this.updateDB(payload)
      console.log(992,w,w.errorid);
    },
    async saveReview()
    {
      this.loading=true;
      var token=Date.now();
      navigator.clipboard.writeText(this.review.review+'\ntoken:' + token);
      this.hostname=window.location.hostname;
      console.log(437,this.hostname);

      this.QRCodeLink='https://'+this.hostname+'/qrcodevalidate/?p='+this.bookingId
      var excluded=['review','title','companion','source'];
      var fb={};
      Object.keys(this.review).forEach(k=>{ if(!excluded.includes(k)) fb[k]=this.review[k]; });
      this.totalScore= Object.values(fb).reduce((a, b) => a/1 + (isNaN(b)?0:b)/1, 0);
      console.log(389,this.totalScore)
      var review= {... this.review}
      review.bookingId=this.bookingId;
      review.token=token;
      review.qrcode=this.QRCodeLink;
      review.totalScore=parseInt(this.totalScore);
      let payload={"action":'saveReview',"payload":review}
      console.log(1259,payload)
      let w= await this.updateDB(payload)
      console.log(992,w,w.errorid);
      this.loading=false;
      console.log(1075,w)
      switch (w.errorid)
      {
        case '0':
          console.log(1078,w)
          this.payloads=w.payloads;
          if (this.partialScore>=parseInt(this.settings.options.reviewThresholdTripAdvisor))
          this.dialog_leave_to_tripadvisor=true
          else this.dialog_thanks=1
          this.reviewSaved=true;
        break;
        case '0001':
          /*
          this.snackbar.color='error'
          this.snackbar.text=w.message
          this.snackbar.active=1;
          */
          this.dialog_duplicated=true;
        break;
      }
    },
    async updateDB(payload){
      try{
          const res = await this.$http.post('/review/review.php', payload);
          console.log(1284,res);
          if (res.data.errorid=='0')
          {
            sessionStorage.setItem('jwt', res.data.jwt);
          }
          else
          {
            console.log(1291);
            //this.$router.push('/auth/login').catch(() => {});
          }
          return res.data;
      } catch(e)
      {
        this.dialog_connection_error=true;
        console.log(e);
      }
    },
  },
};
</script>
<style scoped>
.review-page {
  background: #FFFFFF;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #16211C;
}

/* ---- Brand header ---- */
.brand-card {
  background: #FFFFFF !important;
  border: 1px solid #E3E7E4;
  border-radius: 8px !important;
  box-shadow: none !important;
}

.brand-card-inner {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px;
}

.brand-logo {
  border-radius: 6px;
  flex: 0 0 auto;
}

.brand-name {
  font-size: 16px;
  font-weight: 700;
  color: #0B3B24;
  line-height: 1.3;
}

.brand-address {
  font-size: 13px;
  color: #6B7A70;
  margin-top: 2px;
}

.greeting-block {
  margin: 6px 0;
}

.eyebrow {
  font-size: 15px;
  color: #16211C;
  margin-right: 6px;
}

.guest-name {
  font-size: 15px;
  font-weight: 700;
  color: #0B3B24;
}

/* ---- Sections ---- */
.ta-section {
  margin-top: 18px;
}

.section-title {
  font-size: 19px;
  font-weight: 700;
  color: #0B3B24;
  margin-bottom: 16px;
}

.rating-list {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.rating-row {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.rating-label {
  font-size: 26px;
  font-weight: 600;
  color: #16211C;
  text-transform: uppercase;
}

.rating-row-bottom {
  display: flex;
  align-items: center;
  gap: 12px;
}

.rating-dots ::v-deep .v-icon {
  padding: 0 4px;
  font-size: 30px !important;
}

.rating-state {
  font-size: 18px;
  color: #4A5750;
  text-align: right;
  width: 100%;
  padding-right: 8px;
}

/* ---- Chips ---- */
.chip-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.ta-chip {
  border-radius: 999px !important;
  border: 1.5px solid #D6DAD6 !important;
  color: #16211C !important;
  font-weight: 500;
  background: #FFFFFF !important;
}

.ta-chip-active {
  border: 2px solid #00AF87 !important;
  color: #00543C !important;
  font-weight: 700;
}

/* ---- Inputs ---- */
.tip-line {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  margin-bottom: 4px;
  width: fit-content;
}

.tip-link {
  font-size: 14px;
  color: #16211C;
  text-decoration: underline;
  font-weight: 500;
}

.ta-input ::v-deep .v-input__slot {
  border-radius: 6px !important;
}

.ta-input ::v-deep fieldset {
  border-color: #B9C2BC !important;
}

/* ---- Buttons ---- */
.submit-btn {
  border-radius: 6px !important;
  font-weight: 700;
  font-size: 15px;
  height: 48px !important;
  text-transform: none;
}

/* ---- Bottom social nav ---- */
.social-nav {
  background: transparent !important;
  border-top: 1px solid #E3E7E4;
  box-shadow: none !important;
}

.social-nav ::v-deep .v-btn {
  text-transform: uppercase;
  font-size: 11px;
  letter-spacing: 1px;
  color: #4A5750;
}

/* ---- Dialogs ---- */
.dialog-card {
  border-radius: 10px !important;
  overflow: hidden;
}

.dialog-title {
  font-weight: 700;
  color: #0B3B24;
}

.dialog-text {
  font-size: 15px;
  line-height: 1.6;
  color: #16211C;
}

.tips-list {
  margin: 0;
  padding-left: 20px;
}

.tips-list li {
  margin-bottom: 10px;
}

/* ---- Mobile ---- */
@media (max-width: 600px) {
  .section-title {
    font-size: 17px;
  }
  .ta-section {
    margin-top: 12px;
  }
}
</style>
